import React from "react";
import { Route, Redirect } from "react-router-dom";
import { IonApp, IonRouterOutlet, IonLoading } from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";
import { observer, MobXProviderContext } from "mobx-react";

import HomePage from "./pages/HomePage";
import HeroMarketing from "./components/HeroMarketing";
import "./theme/variables.css";
import "./App.css";

const PublicRoutes = () => {
  return (
    <IonReactRouter>
      <IonRouterOutlet>
        <Route path="/tabs" component={HomePage} />
        <Route path="/" exact={true} render={() => <Redirect to="/tabs/home" />} />
      </IonRouterOutlet>
    </IonReactRouter>
  );
};

const App = () => {
  const { store } = React.useContext(MobXProviderContext);

  return (
    <div className="app-page-wrapper">
      <header className="topbar">
        <div className="shell nav-shell">
          <a className="logo-link" href="/" aria-label="OneHotCode home">
            <img
              src={process.env.PUBLIC_URL + "/assets/img/logo2.png"}
              alt="OneHotCode"
              className="logo desktop-logo"
            />
            <img
              src={process.env.PUBLIC_URL + "/assets/img/logo.png"}
              alt="OneHotCode"
              className="logo mobile-logo"
            />
          </a>

          <nav className="desktop-nav" aria-label="Primary">
            <a
              href="https://calendly.com/onehotcode2026/30min"
              target="_blank"
              rel="noopener noreferrer"
            >
              Schedule a call
            </a>
            <a href="/tabs/settings">Sign in</a>
            <a className="pill-link" href="/tabs/settings">
              Sign up
            </a>
          </nav>

          <a className="mobile-signin" href="/tabs/settings">
            Account
          </a>
        </div>
      </header>

      <main className="page">
        <section className="hero shell">
          <HeroMarketing />

          <div className="app-main-content">
            {!store.authCheckComplete ? (
              <IonApp>
                <IonLoading message="Starting App..." />
              </IonApp>
            ) : (
              <IonApp>
                <PublicRoutes />
              </IonApp>
            )}
          </div>
        </section>
      </main>

      <footer className="footer">
        <div className="shell footer-shell">
          <a
            href="https://aekam.ai"
            target="_blank"
            rel="noopener noreferrer"
            className="aekam-footer"
          >
            <img
              src={process.env.PUBLIC_URL + "/assets/footer-logo.png"}
              alt="Aekam AI"
              className="footer-logo"
            />
          </a>
          <nav>
            <a href="/privacy.html" target="_blank" rel="noopener noreferrer">
              Privacy
            </a>
            <a href="/terms.html" target="_blank" rel="noopener noreferrer">
              Terms
            </a>
            <a href="mailto:support@aekam.ai">Contact</a>
          </nav>
        </div>
      </footer>
    </div>
  );
};

export default observer(App);
